import { type Logger, RootLogger, type RootLoggerType } from "verdi-logging/browser";

export const DashboardModuleNames = {
    i18n: "dashboard:i18n",
    qrScanPanel: "dashboard:add-device:qr-scan-panel",
    addDeviceCard: "dashboard:add-device:card",
    dataViewer: "dashboard:data-viewer",
} as const;

type DeepStringValues<T> = T extends string
    ? T
    : T extends Readonly<Record<string, unknown>>
      ? { [K in keyof T]: DeepStringValues<T[K]> }[keyof T]
      : never;

export type DashboardModuleName = DeepStringValues<typeof DashboardModuleNames>;

const DashboardLogger: RootLoggerType<DashboardModuleName> = RootLogger;

export function createDashboardLogger(module: DashboardModuleName): Logger {
    return DashboardLogger.child({ module });
}
